import { connect, Node } from "../Axios";
import { GET_PREBOOKING_DETAIL, GET_PROPERTY_DETAIL, GET_PROPERTY_LIST, GET_ROOM_RESTRICTION, GET_TERMS_AND_CONDITIONS, SAVE_CONFIRM_BOOKING } from "./ApiUrl";

// PROPERTY List
export const frontPropertyList = async () => {
  try {
    const url = `${GET_PROPERTY_LIST}`;
    const response = await connect.get(url);
   
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
};

// PROPERTY DETAIL
export const frontPropertyDetail = async (PropertyID) => {
  try {
    const url = `${GET_PROPERTY_DETAIL}?PropertyID=${PropertyID}`;
    const response = await connect.get(url);
    
    return response.data;
  } catch (error) {
    console.log(error.message);
  }
};

// PRE BOOKIG DETAILS
export const frontPreBookingDetail = async (PropertyID, CheckIn, CheckOut) => {
  try {
    const url = `${GET_PREBOOKING_DETAIL}?PropertyID=${PropertyID}&CheckIn=${CheckIn}&CheckOut=${CheckOut}`;
    const response = await connect.get(url);
     console.log("Room detail Response",response.data);
    return response.data;
  } catch (error) {
    console.log(error.message);
  }
};



export const SaveComfirmBooking = async (payload) => {
  try {
    const formData = new FormData();

    // Flat fields
    formData.append('PreBookingToken', payload.PreBookingToken || '');
    formData.append('TotalRoomRate', payload.TotalRoomRate || '0');
    formData.append('TotalExtraBedCharges', payload.TotalExtraBedCharges || '0');
    formData.append('TotalPayment', payload.TotalPayment || '0');
    formData.append('Tax', payload.Tax || '0');
    formData.append('TotalAfterTax', payload.TotalAfterTax || '0');
    formData.append('Discount', payload.Discount || '0');
    formData.append('PaymentComment', payload.PaymentComment || '');
    formData.append('CompanyName', payload.CompanyName || '');
    formData.append('RegistrationNumber', payload.RegistrationNumber || '');
    formData.append('RegistrationCompanyName', payload.RegistrationCompanyName || '');
    formData.append('RegistrationCompanyAddress', payload.RegistrationCompanyAddress || '');
    formData.append('MarketSegment', payload.MarketSegment || '');
    formData.append('BusinessSource', payload.BusinessSource || '');
    formData.append('Title', payload.Title || '');
    formData.append('FirstName', payload.FirstName || '');
    formData.append('MiddleName', payload.MiddleName || '');
    formData.append('LastName', payload.LastName || '');
    formData.append('EmailAddress', payload.EmailAddress || '');
    formData.append('Address', payload.Address || '');
    formData.append('MobileNumber', payload.MobileNumber || '');
    formData.append('Country', payload.Country || '');
    formData.append('State', payload.State || '');
    formData.append('City', payload.City || '');
    formData.append('GuaranteeCodes', payload.GuaranteeCodes || '');
    formData.append('PropertyID',payload.PropertyID || '');

    // RoomDetails — har room ka alag JSON object array me
    formData.append('RoomDetails', JSON.stringify(payload.RoomDetails));

    const url = SAVE_CONFIRM_BOOKING;
    const response = await connect.post(url, formData);
    console.log("Response",response)
    console.log("Booking API Response",response.data)
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
};

// Room Restriction
export const FetchRoomRestriction = async (PropertyID, CheckInDate, CheckOutDate, RateCode , RoomCode) => {
  try {
    const url = `${GET_ROOM_RESTRICTION}?PropertyID=${PropertyID}&CheckInDate=${CheckInDate}&CheckOutDate=${CheckOutDate}&RateCode=${RateCode}&RoomCode=${RoomCode}`;
    const response = await connect.get(url);
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
};



export const GetTermsAndConditions = async (PropertyID) => {
  try {
    const url = `${GET_TERMS_AND_CONDITIONS}/${PropertyID}`;
    const response = await Node.get(url);
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
};
